import { briefApi } from 'api'
import { SyncAction } from 'types/Project'

export interface Props {
  id: string
  actionType: SyncAction
  uhubId: string
}

export const postProjectSyncPreview = ({ id, actionType, uhubId }: Props) =>
  briefApi.post(`/projects/${id}/uhub-preview`, { action: actionType, uhubId })
